import fetchWrapper from "@/api/fetch-wrapper";

export const getProlongationAgreementInfo = (number, inn) => {
    const query = `ajax/agreementInfo.php?prolongationNumber=${number}&inn=${inn}`;
    return fetchWrapper.get(query)
}

export const searchGrzByInn = (inn, cars = [], prolongNumber = '') => {
    const params = new URLSearchParams({
        action: 'searchGrz',
        inn: inn,
        prolongationNumber: prolongNumber,
    });

    cars.forEach(car => {
        if (car?.regNum) {
            params.append('regNums[]', car.regNum);
        }
    });

    return fetchWrapper.get(`ajax/agreementInfo.php?${params.toString()}`);
}